import React from 'react';
import { MapPinIcon, MessageCircleIcon, StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
type TestimonialCardProps = {
  name: string;
  city: string;
  comment: string;
  delay?: number;
  accent?: 'orange' | 'pink' | 'sky';
};
const avatarStyles = {
  orange: 'bg-orange-100 text-orange-700',
  pink: 'bg-pink-100 text-pink-700',
  sky: 'bg-sky-100 text-sky-700'
};
export function TestimonialCard({
  name,
  city,
  comment,
  delay = 0,
  accent = 'orange'
}: TestimonialCardProps) {
  const initials = name.split(' ').map(part => part[0]).join('').slice(0, 2);
  return <motion.article initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay
  }} className="flex h-full flex-col rounded-2xl border border-orange-100 bg-white p-4 shadow-md" data-id="element-229">
      <div className="flex items-center justify-between gap-3" data-id="element-230">
        <div className="flex items-center gap-2.5" data-id="element-231">
          <div className={`flex h-9 w-9 items-center justify-center rounded-full text-xs font-black ${avatarStyles[accent]}`} aria-label={`Iniciales de ${name}`} data-id="element-232">
            {initials}
          </div>
          <div data-id="element-233">
            <p className="text-sm font-extrabold text-slate-900" data-id="element-234">{name}</p>
            <p className="flex items-center gap-1 text-[11px] font-medium text-slate-500" data-id="element-235">
              <MapPinIcon className="h-3 w-3" data-id="element-236" />
              {city}
            </p>
          </div>
        </div>
        <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-237">
          {Array.from({
          length: 5
        }).map((_, index) => <StarIcon key={index} className="h-3.5 w-3.5 fill-yellow-400 text-yellow-400" data-id="element-238" />)}
        </div>
      </div>
      <div className="mt-4 rounded-2xl rounded-tl-sm bg-green-50 p-3 text-sm leading-relaxed text-slate-700 ring-1 ring-green-100" data-id="element-239">
        “{comment}”
      </div>
      <p className="mt-3 flex items-center gap-1.5 text-[11px] font-semibold text-slate-400" data-id="element-240">
        <MessageCircleIcon className="h-3.5 w-3.5" data-id="element-241" />
        Testimonio compartido por una docente
      </p>
    </motion.article>;
}